<template>
    <a-switch :default-checked="defaultChecked" :checked="checkedValue" @change="onChange"/>
</template>

<script>
export default {
    name:'y-switch',
    props:{
        checked:{
            type:Number,
            default:0
        },
        defaultChecked:{
            type:Boolean,
            default:true
        }
    },
    model:{
        prop:'checked',
        event:'change'
    },
    data(){
        return {
            checkedValue:false
        }
    },
    watch:{
        checked:{
            handler(val){
                this.checkedValue = Boolean(val)
            },
            immediate:true
        }
    },
    methods:{
        onChange(){
            this.$emit('change',Number(!this.checkedValue))
        }
    }
}
</script>